<template>
	<div v-loading="loading" class="user-center-container">
		<!-- 消息列表 -->
		<div class="user-center-header filter-container">
			<div class="filter-tabs">
				<div :class="['tab-item', { active: searchForm.msgTags === '' }]" @click="handleTabChange('')">
					全部类型
				</div>
				<div
					v-for="(tab, index) in messagesTagList"
					:key="index"
					:class="['tab-item', { active: searchForm.msgTags === tab.dictCode }]"
					@click="handleTabChange(tab.dictCode)"
				>
					{{ tab.dictValue }}
				</div>
			</div>

			<div class="filter-options">
				<div class="date-filter">
					<div
						v-for="(date, index) in dateOptions"
						:key="index"
						:class="['date-item', { active: currentDate === date.value }]"
						@click="handleDateChange(date.value)"
					>
						{{ date.label }}
					</div>

					<el-date-picker
						v-if="currentDate === 'custom'"
						v-model="customData"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
						@change="handleChangeCustomDate"
					></el-date-picker>
				</div>
			</div>
		</div>
		<div class="user-center-content">
			<!-- 消息筛选区 -->

			<div class="btn-group">
				<el-checkbox v-model="onlyUnread" @change="handleChangeUnread">仅看未读</el-checkbox>
				<el-button @click="markAllRead">
					<svg-icon icon-class="clear"></svg-icon>
					全部已读
				</el-button>
				<el-button @click="handleDeleteMessages">
					<svg-icon icon-class="delete"></svg-icon>
					全部删除
				</el-button>
			</div>

			<div class="message-container">
				<div v-if="messageList.length" class="message-content">
					<div v-for="(item, index) in messageList" :key="index" class="message-row" @click="handleToMessage(item)">
						<div class="message-title" :class="{ isNoRead: item.msgConsumeState === 0 }">
							<span>[{{ item.msgTagsName }}]</span>
							{{ item.msgTitle }}
							<span class="time">{{ formatDateTime(item.createTime) }}</span>
						</div>
						<div v-if="item.msgContent.length <= 55" class="message-text">
							{{ item.msgContent }}
						</div>
						<el-tooltip v-else class="item" effect="dark" :content="item.msgContent" placement="top">
							<div class="message-text">
								{{ item.msgContent }}
							</div>
						</el-tooltip>

						<!-- <div class="row-item">
							<el-button v-if="item.msgConsumeState === 0" type="text" @click="handleMarkAsRead(item)">标记为已读</el-button>
							<el-button type="text" @click="lookMessageDetail(item)">查看详情</el-button>
						</div> -->
					</div>
				</div>
				<!-- 数据为空 -->
				<empty-content v-else empty-text="暂无资质信息"></empty-content>

				<!-- 分页 -->
				<div v-if="messageList.length" class="pagination-container">
					<jr-pagination
						:limit="pageOptions.limit"
						:page.sync="pageOptions.page"
						:total="pageOptions.total"
						layout="prev, pager, next"
						prev-text="上一页"
						next-text="下一页"
						@change="handlePaginationChange"
					></jr-pagination>
				</div>
			</div>
		</div>

		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleCancelPay">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>
		<!-- <jr-dialog
			:visible.sync="messageDetailVisible"
			:title="detailInfo.msgTitle"
			width="50%"
			top="100px"
			:append-to-body="true"
			:showBtn="false"
		>
			<template v-if="messageDetailVisible" slot="content">
				<p class="detainText">{{ detailInfo.msgContent }}</p>
			</template>
		</jr-dialog> -->
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import JrPagination from '@/components/Pagination'
	import { getUserMessageList, handleSetRead, handleAllDelete, getCountUserMessage } from '@/api/user/message'
	import { mapState } from 'vuex'
	import { mapDictionaries } from '@/store/dictionary-helper'
	export default {
		name: 'UserMessage',
		components: { JrPagination, JrDialog, PaymentDialog },
		props: {},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				searchForm: {
					msgTags: '',
					startTime: '',
					endTime: ''
				},
				// 时间筛选选项
				dateOptions: [
					{ label: '全部时间', value: 'allTime' },
					{ label: '今日', value: 'today' },
					{ label: '近7天', value: 'week' },
					{ label: '近30天', value: 'month' },
					{ label: '自定义', value: 'custom' }
				],
				currentDate: 'allTime',
				customData: '',

				// 未读筛选
				onlyUnread: false,
				// 消息详情弹窗
				messageDetailVisible: false,

				// 消息列表数据
				messageList: [],
				detailInfo: {},
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				}
			}
		},
		computed: {
			...mapState({
				userUnreadMessageCount: state => state.user.userUnreadMessageCount
			}),
			// 使用自定义的映射函数
			...mapDictionaries('dictionary', ['messagesTagsDict']),
			// 是否全选
			isAllSelected: {
				get() {
					return this.messageList.length > 0 && this.messageList.every(item => item.checked)
				},
				set(val) {
					// 在handleSelectAllChange中处理
				}
			},
			// 是否部分选中
			isIndeterminate() {
				const selectedCount = this.messageList.filter(item => item.checked).length
				return selectedCount > 0 && selectedCount < this.messageList.length
			},
			// 是否有被选中的
			isHasSelected() {
				return this.messageList.some(item => item.checked)
			},
			// 门户端只显示特定类型的消息
			messagesTagList() {
				return this.messagesTagsDict.filter(f => f.tags === 'home')
			}
		},
		watch: {
			messagesTagsDict: {
				immediate: true,
				handler(newVal) {
					console.log('messagesTagsDict changed:', newVal)
					if (newVal && newVal.length > 0) {
						this.initMessageList()
					}
				}
			}
		},
		created() {},
		mounted() {},
		methods: {
			initMessageList() {
				this.loading = true
				const params = {
					msgType: '1',
					msgTags: this.searchForm.msgTags, //消息类别
					startTime: this.searchForm.startTime, // 开始时间
					endTime: this.searchForm.endTime, // 结束时间
					msgConsumeState: this.searchForm.msgConsumeState, // 消息状态 0未读 1已读
					page: this.pageOptions.page,
					size: this.pageOptions.limit
				}
				// 门户端只显示特定类型的消息
				if (!params.msgTags) {
					params.msgTagList = this.messagesTagList.map(m => m.dictCode).join(',')
				}
				getUserMessageList(params)
					.then(response => {
						if (response.code === 200) {
							response.data.records.forEach(item => {
								item.checked = false
							})
							this.messageList = response.data.records
							this.pageOptions.total = response.data.total
						}
						this.loading = false
					})
					.catch(error => {
						this.loading = false
					})
				// TODO: 初始化消息列表数据
			},
			// 批量删除消息
			handleDeleteMessages() {
				const params = {
					msgType: '1',
					msgTags: this.searchForm.msgTags
				}
				this.$modal
					.confirm('是否确定删除？')
					.then(() => {
						handleAllDelete(params).then(response => {
							if (response.code === 200) {
								this.$message({
									message: '删除成功',
									type: 'success'
								})
								this.initMessageList()
							}
						})
					})
					.catch(() => {})
			},
			handleChangeUnread(value) {
				console.log(value)
				if (value) {
					this.searchForm.msgConsumeState = '0'
				} else {
					this.searchForm.msgConsumeState = ''
				}
				this.initMessageList()
			},
			// 全选/取消全选
			handleSelectAllChange(val) {
				this.messageList.forEach(item => {
					item.checked = val
				})
			},
			// TODO: 根据tab筛选消息
			handleTabChange(tab) {
				this.searchForm.msgTags = tab
				this.initMessageList()
			},
			// 切换时间查询
			handleDateChange(date) {
				this.currentDate = date
				const now = new Date()
				const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
				const weekAgo = new Date(today)
				const monthAgo = new Date(today)
				// 修正为本地时间格式
				const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
					today.getDate()
				).padStart(2, '0')}`

				switch (date) {
					case 'allTime':
						this.searchForm.startTime = ''
						this.searchForm.endTime = ''
						break
					case 'today':
						this.searchForm.startTime = todayStr
						this.searchForm.endTime = todayStr
						break
					case 'week':
						weekAgo.setDate(weekAgo.getDate() - 6) // 包含今天共7天
						this.searchForm.startTime = weekAgo.toISOString().split('T')[0]
						this.searchForm.endTime = todayStr
						break
					case 'month':
						monthAgo.setMonth(monthAgo.getMonth() - 1)
						monthAgo.setDate(monthAgo.getDate() + 1) // 包含今天共30天
						this.searchForm.startTime = monthAgo.toISOString().split('T')[0]
						this.searchForm.endTime = todayStr
						break
					case 'custom':
						// 自定义时间段由el-date-picker处理
						break
				}
				if (date !== 'custom') {
					this.initMessageList()
				}
			},
			// 自定义时间查询
			handleChangeCustomDate(value) {
				if (value) {
					this.searchForm.startTime = value[0]
					this.searchForm.endTime = value[1]
				}
				this.initMessageList()
			},
			// 全部已读
			markAllRead() {
				const params = {
					consumeType: '1',
					msgIds: this.messageList.map(item => item.id)
				}
				const paramsNoRead = {
					msgType: '1',
					msgConsumeState: '0',
					msgTags: this.searchForm.msgTags
				}
				if (!paramsNoRead.msgTags) {
					paramsNoRead.msgTagList = this.messagesTagList.map(m => m.dictCode).join(',')
				}
				getCountUserMessage(paramsNoRead).then(response => {
					if (response.code === 200 && response.data > 0) {
						handleSetRead(params).then(response => {
							if (response.code === 200) {
								this.initMessageList()
								this.getUnreadMessageCount()
							}
						})
					} else {
						this.$message({
							message: '暂无未读消息',
							type: 'warning'
						})
					}
				})
			},
			// 全部已读后获取未读消息
			getUnreadMessageCount() {
				const params = {
					msgType: '1',
					msgConsumeState: '0',
					msgTags: this.searchForm.msgTags
				}
				if (!params.msgTags) {
					params.msgTagList = this.messagesTagList.map(m => m.dictCode).join(',')
				}
				getCountUserMessage(params).then(response => {
					if (response.code === 200) {
						this.$store.dispatch('user/setUnreadMessageCount', response.data)
					}
				})
			},
			// 单项选择变化
			handleItemSelectChange() {
				// 不需要额外处理，computed属性会自动更新
			},
			// 用户取消收藏
			handleMarkAsRead(item) {
				const params = {
					consumeType: '2',
					msgIds: [item.id]
				}
				handleSetRead(params).then(response => {
					if (response.code === 200) {
						this.initMessageList()
					}
				})
			},
			// 查看消息详情
			lookMessageDetail(item) {
				this.detailInfo = item
				this.messageDetailVisible = true
			},
			handleConfirm() {
				this.messageDetailVisible = false
			},
			handleCancel() {
				this.messageDetailVisible = false
			},
			// 分页变化
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.initMessageList()
			},
			formatDateTime(dateTime) {
				if (!dateTime) return ''
				const [datePart, timePart] = dateTime.split(' ')
				const [year, month, day] = datePart.split('-')
				console.log(year)
				const [hours, minutes] = timePart.split(':')
				return `${month}-${day} ${hours}:${minutes}`
			},
			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},
			handleCancelPay() {
				this.payVisible = false
			},
			// 点击不同消息类型做出不同处理
			handleToMessage(item) {
				switch (item.msgTagsName) {
					case '会员福利':
						this.payVisible = true
						break
					case '监控预警动态':
						if (item.linkBusinessType === '2') {
							this.$router.push({
								path: '/qualification-query/personDetail',
								query: {
									id: item.linkBusinessId // 传递详情ID参数
								}
							})
						} else if (item.linkBusinessType === '3') {
							this.$router.push({
								name: 'SearchCompanyDetail', // 使用路由名称跳转
								query: {
									id: item.linkBusinessId // 传递详情ID参数
								}
							})
						}
						break
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	::v-deep .el-date-editor--daterange {
		margin-left: 15px;
	}
	::v-deep .el-dialog__body {
		padding-bottom: 20px;
	}
	.detainText {
		white-space: pre-wrap;
		word-break: break-word;
		line-height: 1.6;
		font-size: 18px;
		color: #606266;
	}
	.btn-group {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 0px !important;
		::v-deep {
			.el-button {
				padding: 5px 10px;
				margin-left: 15px;
				border-radius: 0px;
				font-size: 16px;
				&:hover {
					background: none;
				}
			}
		}
	}
	.date-filter {
		width: 100%;
		position: relative;
		.date-item {
			& + .date-item {
				margin-left: 0px !important;
			}
		}
		::v-deep {
			.el-range-editor.el-input__inner {
				height: 35px;
				border-radius: 0px;
			}
			.el-range-separator {
				line-height: 26px;
			}
		}
	}
	.message-container {
		.message-row {
			padding: 20px 0px;
			border-bottom: 1px dashed #dcdcdc;
			padding-left: 20px;
			cursor: pointer;
			transition: all 0.3s ease; // 添加过渡效果

			&:hover {
				background-color: #f5f7fa; // 鼠标悬停时的背景色
				transform: translateX(5px); // 轻微右移效果
			}
			.message-title {
				font-weight: bold;
				color: #333;
				position: relative;
				span {
					color: #427fd1;
					margin-right: 5px;
					font-weight: normal;
				}
				.time {
					float: right;
					font-size: 14px;
					color: #ababab;
				}
				&::before {
					content: '';
					position: absolute;
					left: -20px;
					top: 50%;
					transform: translateY(-50%);
					width: 8px;
					height: 8px;
					border-radius: 50%;
					background-color: #cccccc;
				}
			}
			.isNoRead {
				&::before {
					background-color: #ff1a2e;
				}
			}
			.message-text {
				color: #8f8f8f;
				margin-top: 10px;
				max-width: 800px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
</style>
<style lang="scss" scoped>
	.el-tooltip__popper {
		width: 400px; // 可以调整为您需要的宽度
		max-width: 80%; // 或者设置最大宽度百分比
		word-break: break-all; // 如果需要自动换行可以添加这个
	}
	.active {
		text-decoration: underline;
		text-decoration-color: #409eff;
		text-decoration-thickness: 2px;
		text-underline-offset: 6px;
	}
	.tab-item:hover,
	.date-item:hover {
		text-decoration: underline;
		text-decoration-color: #409eff;
		text-decoration-thickness: 2px;
		text-underline-offset: 6px;
	}
</style>
